import { Paper } from "@mui/material";

interface PageCardProps {
  children: React.ReactNode;
}

const PageCard: React.FC<PageCardProps> = ({ children }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        padding: 3,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.06)",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }}
    >
      {children}
    </Paper>
  );
};

export default PageCard;
